import { strFilter } from "@/utils/filter";

const handlerEvent = (modifiers, target) => {
  return e => {
    if (e && e.target) {
      if (e.isComposing) return;
      const t = e.target;
      const result = strFilter(t.value, modifiers);
      if (result === t.value) return;
      t.value = result;
      target.dispatchEvent(new Event("input", { bubbles: true }));
    }
  };
};

let inputEvent;

export default {
  bind(el, binding) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    const textArea = el.tagName === "TEXTAREA" ? el : el.querySelector("textarea");
    if (!input && !textArea) return;
    const target = input || textArea;
    const modifiers = Object.keys(binding.modifiers);
    inputEvent = handlerEvent(modifiers, target);
    target.addEventListener("input", inputEvent);
    target.addEventListener("compositionend", inputEvent);
  },
  unbind(el) {
    const input = el.tagName === "INPUT" ? el : el.querySelector("input");
    const textArea = el.tagName === "TEXTAREA" ? el : el.querySelector("textarea");
    if (!input && !textArea) return;
    const target = input || textArea;
    target.removeEventListener("input", inputEvent);
    target.removeEventListener("compositionend", inputEvent);
  }
};
